export const TRANSPORT_COLUMN_DESC_VIEW = {
    whenNextBus: 'whenNextBus',
    whereBusNow: 'whereBusNow',
    busDirection: 'busDirection',
}
